export default function ResponsibleBanner() {
  return (
    <div className="bg-ink text-cream text-center py-2 px-4 text-[10px] sm:text-xs tracking-widest uppercase font-semibold border-b border-cream/10" data-testid="responsible-banner">
      <span className="text-pink-brand">•</span> Drink Responsibly · Legal drinking age varies by state <span className="text-pink-brand">•</span>
    </div>
  );
}
